import React, {Component} from 'react'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'
import Header from '../Header'
import {Link} from 'react-router-dom'
import _ from 'lodash'
import * as UrlHelpers from '../../helpers/urlHelpers'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import UserOrLogin from '../UserOrLogin'
import AddWall from '../walls/AddWall'
import EnsureUser from '../EnsureUser'
import Loading from '../Loading'
import ListProblems from '../problems/ListProblems'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import Corona from '../Corona'
import Reservations from '../reservations/Reservations'

class Gym extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCreatingWall: false,
      isAddingWall: false,
      loading: false,
    }

    this.handleAddWall = this.handleAddWall.bind(this)
  }

  handleAddWall() {
    this.setState({
      isAddingWall: !this.state.isAddingWall,
    })
  }

  render() {
    let gym = this.props.gym
    let gymId = gym && gym.id
    let gymName = (gym && gym.name) || gymId
    let walls = (gym && gym.walls) || []
    let hasInfo = false
    let hasReservations = false
    return (
      <div className="container">
        <Header>
          <div
            className="breadcrumbs"
            style={{
              display: 'flex',
            }}>
            <Link to={UrlHelpers.gymsPath}>Gyms</Link>
            <span className="pipe">|</span>
            <Link to={UrlHelpers.gymPath(gymId)}>{gymName}</Link>
            <span className="pipe">|</span>
            <UncontrolledDropdown className="wall-dropdown">
              <DropdownToggle tag="div" className="wall-dropdown" caret>
                walls
              </DropdownToggle>
              <DropdownMenu>
                {_.map(walls, wall => {
                  return (
                    <DropdownItem tag="div" key={wall.id}>
                      <Link to={UrlHelpers.wallPath(gymId, wall.id)}>
                        {wall.name}
                      </Link>
                    </DropdownItem>
                  )
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <UserOrLogin />
        </Header>
        <Tabs className="full-width">
          <TabList className="black" style={{marginLeft: -40}}>
            {hasInfo && <Tab>Info</Tab>}
            <Tab>Walls</Tab>
            <Tab>Problems</Tab>
            {hasReservations && <Tab>Reserve</Tab>}
          </TabList>
          {hasInfo && <TabPanel className="black">
                      <Corona />
                    </TabPanel>}

          <TabPanel>
            {!this.state.isAddingWall && (
              <div className="thumbnail-group">
                {!this.state.isAddingWall && this.state.loading && (
                  <Loading inline />
                )}
                {_.map(walls, wall => {
                  return (
                    <Link
                      key={wall.id}
                      className="thumbnail"
                      to={'/gyms/' + gym.id + '/walls/' + wall.id}>
                      <div className="img-wrapper">
                        <img src={wall.wallUrl} alt=""></img>
                      </div>
                      <div>{wall.name}</div>
                    </Link>
                  )
                })}
              </div>
            )}
            <div>
              {!this.state.isAddingWall && (
                <LaddaButton
                  onClick={this.handleAddWall}
                  data-color="mint"
                  data-style={SLIDE_UP}
                  data-spinner-color="#ddd"
                  className={'floating-bottom-right-button'}>
                  +
                </LaddaButton>
              )}
              {this.state.isAddingWall && (
                <EnsureUser>
                  <AddWall cancel={this.handleAddWall} gym={gym} />
                </EnsureUser>
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="black full-width">
              <div className="white">
                <ListProblems
                  problems={this.props.problems}
                  display="condensed"
                />
              </div>
            </div>
          </TabPanel>
          {hasReservations && <TabPanel>
                      <div className="black full-width">
                        <div className="white">
                          <Reservations gym={gym} />
                        </div>
                      </div>
                    </TabPanel>}
        </Tabs>
      </div>
    )
  }
}

export default Gym



// WEBPACK FOOTER //
// ./src/components/gyms/Gym.jsx